import IconView from "../IconView";


let FileIconView = IconView.createPlugin("Image", {

    initialize() {
        FileIconView.__super__.initialize.apply(this, arguments);
    },

    onOpen() {

    }
});

export default FileIconView;
